<template>
  <section class="buildingsGuidelines">
    <div class="mb-3">Follow these guidelines when editing to ensure formatting is correct:</div>
    <div>
      <ul>
        <li>The "Sensor Key" is the <strong>unique ID</strong> per sensor.</li>
        <li>A new "Sensor Key" value will <strong>create</strong> a new sensor.</li>
        <li>An existing "Sensor Key" value will <strong>update</strong> that existing sensor.</li>
        <li>In the "Floors" value field, be sure to separate floor names in the cell with a <strong>comma listing them from lowest to highest (i.e. "Parking, Lobby, 2, 3, 4, 5")</strong>.</li>
        <li>Because the "Sensor Key" is used in the spaces file to associate all sensor attributes to mapped spaces, be sure to <strong>input Sensor Key values that are easy to remember and make sense</strong> when associating spaces.</li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name: 'sensorsSteps',
}
</script>
<style lang="scss" scoped>
</style>
